;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import Img from 'components/ui/Img';

import styles from './Slide.module.scss';

const Slide = ({ slot, image, animationState }) => {
    return (
        <div
            className={cx(
                styles.slide,
                [styles[`slot-${slot}`]],
                [styles[`${animationState}`]],
                {
                    [styles['no-transition']]: slot > 4 || slot < 1,
                }
            )}
        >
            <Img
                src={image.url}
                width={image?.width}
                height={image?.height}
                fallbackImageWidth={800}
                alt={image?.description || ''}
                customSources={[
                    {
                        breakpoint: 1920,
                        src: image.url,
                        imageWidth: 1920 / 3,
                    },
                    {
                        breakpoint: 1440,
                        src: image.url,
                        imageWidth: 1440 / 3,
                    },
                    {
                        breakpoint: 1024,
                        src: image.url,
                        imageWidth: Math.round(1024 / 3),
                    },
                    {
                        breakpoint: 768,
                        src: image.url,
                        imageWidth: 768 / 2,
                    },
                    {
                        src: image.url,
                        imageWidth: 400,
                    },
                ]}
                priority
            />
        </div>
    );
};

Slide.propTypes = {
    slot: PropTypes.number.isRequired,
    image: PropTypes.object.isRequired,
    animationState: PropTypes.string.isRequired,
};

export default Slide;
